import { RootState } from "../../../redux-store";

export const selectNotebooks = (state: RootState) =>
  state.data.notebooks.entities;
